import styled from 'styled-components';
import dayjs from 'dayjs';

import ModalBase from 'components/Modal/ModalBase';
import { IconClose, IconTick } from 'assets/icons';
import { Option } from 'types/common.types';
import { MeData } from 'graphQL/Auth/types';
import { useUserInformation } from 'graphQL/Zustand/useUserInformation';

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 32px 20px;

  position: sticky;
  top: 0;
  z-index: 20;
  background-color: #fff;

  > h6 {
    margin: 0;

    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #1b1c1e;
  }

  > svg {
    width: 32px;
    height: 32px;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    padding: 24px 20px;

    > svg {
      width: 24px;
      height: 24px;
    }
  }
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  padding: 0px 0px 36px;
  margin-top: 4px;

  ul {
    padding: 0;
    margin: 0;

    list-style: none;

    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;

      list-style: none;

      width: 100%;
      height: 42px;

      padding: 0px 20px;

      font-size: 16px;
      font-weight: 400;
      color: rgba(70, 71, 76, 1);

      background-color: white;

      cursor: pointer;

      &.selected {
        color: rgba(0, 102, 255, 1);
        font-weight: 500;
      }

      &:hover {
        background-color: rgba(245, 246, 247, 1);
      }
    }
  }
`;

interface Props {
  isMobile: boolean;
  handleSelectingMonthModal: () => void;
  mappedBookingDateList: {
    label: string;
    value: string;
  }[];
  selectedMonth: Option;
  handleSelectingMonth: (value: Option) => void;
  hostCreatedAt: dayjs.Dayjs;
}

function SelectingMonthModal({
  isMobile,
  handleSelectingMonthModal,
  mappedBookingDateList,
  selectedMonth,
  handleSelectingMonth,
  hostCreatedAt,
}: Props) {
  const currentDate = dayjs();

  const generatedMonthList = [];

  let hostCreatedAtMonth = hostCreatedAt.startOf('month');

  while (
    hostCreatedAtMonth.isBefore(currentDate) ||
    hostCreatedAtMonth.isSame(currentDate, 'month')
  ) {
    /* 호스트 가입달 부터 현재달 까지 */
    generatedMonthList.push({
      label: hostCreatedAtMonth.format('YYYY년 M월'),
      value: hostCreatedAtMonth.valueOf().toString(),
    });

    hostCreatedAtMonth = hostCreatedAtMonth.add(1, 'month');
  }

  for (let i = 0; i < 2; i++) {
    /* 현재 달보다 2달 더 보여줘야함. */
    generatedMonthList.push({
      label: hostCreatedAtMonth.format('YYYY년 M월'),
      value: hostCreatedAtMonth.valueOf().toString(),
    });

    hostCreatedAtMonth = hostCreatedAtMonth.add(1, 'month');
  }

  const monthList =
    generatedMonthList.length > 0 ? generatedMonthList : mappedBookingDateList;

  return (
    <ModalBase
      isMobile={isMobile}
      handleModal={handleSelectingMonthModal}
      useCustomHeader
    >
      <ModalHeader>
        <h6>월 선택하기</h6>

        <IconClose color="#70737C" onClick={handleSelectingMonthModal} />
      </ModalHeader>

      <ModalBody>
        <ul>
          {monthList
            .map((opt, idx) => {
              const isSelected = opt.value === selectedMonth?.value;

              return (
                <li
                  key={opt.value}
                  data-keyword={opt.value}
                  className={isSelected ? 'selected' : ''}
                  onClick={() => {
                    handleSelectingMonth(opt);
                    handleSelectingMonthModal();
                  }}
                >
                  {opt.label}

                  {isSelected && <IconTick width={24} height={24} />}
                </li>
              );
            })
            .reverse()}
        </ul>
      </ModalBody>
    </ModalBase>
  );
}

export default SelectingMonthModal;
